import { Component, Input } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { ProductPricing } from 'src/app/models/product-pricing.model';
import { BuyingGroups } from 'src/app/models/buying-groups.model';
import { Warehouse } from 'src/app/models/warehouse.model';
import { tap, Observable, from } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CrudService } from 'src/app/services/crud.service';
import { DxDataGridModule, DxLoadPanelModule } from 'devextreme-angular';
import { DataFormatService } from 'src/app/services/data-format.service';

@Component({
    selector: 'app-products-pricing',
    templateUrl: './products-pricing.component.html',
    styleUrls: ['./products-pricing.component.css'],
    imports: [ AsyncPipe, DxDataGridModule, DxLoadPanelModule ],
    standalone: true
})
export class ProductsPricingComponent {
  @Input() key: string;
  // The parent row's LF drives an LF-WIDE pricing view: the API returns every pricing row
  // sharing the LF across all distributor SKUs/warehouses (labelled by the Code column).
  // Empty-LF products stay scoped to their own code. Inserted rows are always stamped with
  // the PARENT identity (code + LF) below.
  @Input() liquorfileNumber: string;
  @Input() item: any;
  detailsLoading: boolean = true;
  data$: Observable<ProductPricing[]>;
  buyingGroups$: Observable<BuyingGroups[]>;
  warehouses$: Observable<Warehouse[]>;
  apiUrl: string = environment.baseApiUrl;
  currencyFormat: object;


  constructor(private crudService: CrudService, dataFormat: DataFormatService) {
    this.currencyFormat = dataFormat.currencyFormat();
    this.data$ = from([]);
    this.buyingGroups$ = from([]);
    this.warehouses$ = from([]);
   }

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    const lfFilter = this.liquorfileNumber != null
      ? `?liquorfile_number=${encodeURIComponent(this.liquorfileNumber)}`
      : '';
    this.data$ = this.crudService.newGetData(`${this.apiUrl}products-pricing/${this.key}${lfFilter}`).pipe(
      tap(() => {
        this.buyingGroups$ = this.crudService.newGetData(`${this.apiUrl}buying-groups`);
        this.warehouses$ = this.crudService.newGetData(`${this.apiUrl}warehouses`);
        this.detailsLoading = false;
      })
    );
  }

  insertRow(e: any) {
    e.data.product_code = this.key;
    e.data.liquorfile_number = this.liquorfileNumber ?? '';
    this.crudService.insertData(`${this.apiUrl}products-pricing`, e.data).subscribe((result) => {
      this.loadData();
    });
  }

  updateRow(e: any) {
    console.log(e);
    this.crudService.updateData(`${this.apiUrl}products-pricing`, e.key.id, e.newData).subscribe((result) => {
      this.loadData();
    });
  }

}
